import React from 'react';

const Batch = ({ classNames, text }) => (
  <div className={`pipeline end ${classNames}`}>
    <div className="text">{text}</div>
  </div>
);

export default Batch;
